export const SMALL_BUSTED = 'small busted - carry at bust';
export const SMALL_HIPPED = 'small hips - carry at hips';
